module.exports = __webpack_public_path__ + "img/56_87.2bd54b0f.png";